// extracted by mini-css-extract-plugin
module.exports = {"row":"style_row__24zGF","label":"style_label__PVc0L"};